(function(root,factory){const api=factory();if(typeof module==='object'&&module.exports)module.exports=api;else root.BuceAHEngine=api;})(typeof window==='object'?window:globalThis,function(){
 'use strict';
 const CASH={2:1500000,3:2500000,4:4000000,5:5000000};
 const FIXED=['Zapatillas · ahorro adicional por cantidad'];
 const GIFT=['Zapatillas · paga 5 y lleva 6'];
 const money=n=>'$'+Math.round(n/100).toLocaleString('es-CO');
 const integer=n=>Number.isSafeInteger(Number(n))&&Number(n)>=0?Number(n):NaN;
 function evaluate(cart){
  const items=Array.isArray(cart.items)?cart.items:[];
  let pairs=0,fixed=0,gift=0,giftUnits=0,min=Infinity,invalid=false;
  for(const line of items){
   const qty=integer(line.quantity),price=integer(line.original_price);
   if(!Number.isFinite(qty)||!Number.isFinite(price)||qty<1){invalid=true;continue;}
   if(line.shoe===true){pairs+=qty;min=Math.min(min,price);}
   let allocated=0;
   for(const a of line.allocations||[]){
    const amount=integer(a.amount);if(!Number.isFinite(amount)){invalid=true;continue;}allocated+=amount;
    const isFixed=FIXED.includes(a.title),isGift=GIFT.includes(a.title);
    if(!isFixed&&!isGift)continue;
    if(line.shoe!==true||a.type==='discount_code'){invalid=true;continue;}
    if(isFixed)fixed+=amount;
    if(isGift){gift+=amount;giftUnits+=price>0?amount/price:NaN;}
   }
   if(integer(line.original_line_price)!==price*qty||integer(line.final_line_price)!==price*qty-allocated)invalid=true;
  }
  // Order-scoped allocations for this shoe promotion are not certified here.
  if((cart.order_allocations||[]).some(a=>FIXED.includes(a.title)||GIFT.includes(a.title)))invalid=true;
  const expected=pairs>=6?'gift':CASH[pairs]||0;
  const confirmed=cart.currency==='COP'&&!invalid&&(pairs>=6?gift>0&&gift===min&&giftUnits===1&&fixed===0:fixed===expected&&gift===0);
  const actual=pairs>=6?gift:fixed,level=Math.min(6,pairs);
  let current=pairs===0?'Tu ahorro empieza con 2 pares':pairs===1?'Tienes 1 par en tu carrito':pairs>=6?'1 par gratis aplicado · Ahorras '+money(actual):'Ahorro aplicado: '+money(actual);
  if(!confirmed&&pairs>0)current='Meta con '+pairs+' pares: '+(pairs>=6?'1 par gratis':pairs===1?'sin descuento por cantidad':money(expected))+' · Descuento por confirmar';
  const next=pairs===0?'Elige tus primeros pares':pairs===1?'Agrega 1 para ahorrar $15.000':pairs<5?'Agrega 1 para ahorrar '+money(CASH[pairs+1])+' en este pedido':pairs===5?'Agrega 1: eliges 6 y pagas 5':'';
  return {pairs,level,expected,actual,confirmed,fixed,gift,giftUnits,current,next,invalid};
 }
 function tracker(storage){
  let current=null,high=0,pending=null,identity='',record={high:0,seen:[],first:false};
  function key(token){let h=2166136261;for(const ch of String(token||'unknown')){h^=ch.charCodeAt(0);h=Math.imul(h,16777619);}return 'buce-ah-v1-'+(h>>>0).toString(36);}
  function save(){try{storage.setItem(identity,JSON.stringify(record));}catch(e){}}
  function accept(cart,result,intent){
   const id=key(cart.token);
   if(identity!==id){
    let saved;try{saved=JSON.parse(storage.getItem(id));}catch(e){}
    const firstAdd=current?.pairs===0&&intent==='add'&&!saved&&result.pairs>0;
    identity=id;record=saved||{high:0,seen:[],first:false};pending=null;
    high=firstAdd?Number(record.high)||0:Math.max(Number(record.high)||0,result.level);
    current=firstAdd?{pairs:0,level:0}:result;persistentBaseline();if(!firstAdd)return null;
   }
   const previous=current;current=result;
   if(intent==='restore'||intent==='remove'||result.pairs<(previous?.pairs||0)){pending=null;high=Math.max(high,result.level);persistentBaseline();return null;}
   if(result.pairs>(previous?.pairs||0)&&intent==='add'&&result.level>high)pending=result.level;
   high=Math.max(high,result.level);persistentBaseline();
   if(pending!==result.level||!result.confirmed)return null;
   const level=pending;
   if(level===1){if(record.first)return null;return {level:1,message:'Agrega otro par y desbloquea $15.000 de ahorro.'};}
   if(record.seen.includes(level))return null;
   return {level,message:level===6?'¡Lo lograste: un par gratis!':level===2?'¡Desbloqueaste tu primer ahorro!':'¡Desbloqueaste '+money(result.actual)+' de ahorro!'};
  }
  function persistentBaseline(){record.high=high;save();}
  function ack(reward){pending=null;if(reward.level===1)record.first=true;for(let n=2;n<=reward.level;n++)if(!record.seen.includes(n))record.seen.push(n);save();}
  return {accept,ack};
 }
 return {evaluate,tracker,money,FIXED,GIFT};
});
